<template lang="pug">
  div.consume
    van-dropdown-menu(class="select_box")
      van-dropdown-item(v-model="active", :options="status")
    van-collapse(v-model="record", accordion)
      van-list(v-model="listLoading", @load="onListLoad", :loading-text="$t('loading')", :finished-text="$t('noMore')", error-text="...", :finished="finished")
        div(class="hst_box van-clearfix", v-for='(item, key) in orderList', v-if="item.status > -1", :key="key" @click="toChatPage(item)")
          van-collapse-item(class="consume_list")
            template(#icon)
              img(class="consume_icon", :src="item.appIcon")
            template(#title)
              p.title {{item.goodsName}}
              p.time {{formatDate(item.paySuccessTime || item.createTime, true)}}
            template(#value)
              p.status {{formatStatus(item.status)}}
            p {{$t('orderID')}}{{item.id}}
            p {{$t('accountUID')}}{{item.uid}}
            p {{$t('totalAmount')}}{{item.currency}}  {{item.totalMoney}}
            p {{$t('paymentChannel')}}{{item.orderTypeName}}
            p(v-if="item.createTime") {{$t('orderCreationTime')}}{{formatDate(item.createTime)}}
            p(v-if="item.paySuccessTime") {{$t('orderPaymentTime')}}{{formatDate(item.paySuccessTime)}}
            p(v-if="item.notifyTime") {{$t('orderDeliveryTime')}}{{formatDate(item.notifyTime)}}
            p {{$t('gameName')}}{{item.appName}}
            p(v-if="item.serverName !== ' '") {{$t('serverName')}}{{item.serverName}}
            p(v-if="item.roleName !== ' '") {{$t('roleName')}}{{item.roleName}}
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import Qs from 'qs';

export default {
  name: 'Consume',
  data($vm){
    return{
      active: '',
      record: '',
      orderList:[],
      pageNumber: 1,
      listLoading: false,
      finished: false,
      loadStatus: true
    }
  },
  created(){
    this.getPOrderList(Qs.stringify({
      uid: this.uid,
      deviceId: this.deviceId,
      accessToken: this.token,
      pageNumber: 1,
      language: this.lang
    }))
  },
  methods:{
    ...mapActions('user', ['getPOrderList']),
    onListLoad(){
      if(this.loadStatus){
        return false
      }
      this.loadStatus = true
      this.pageNumber += 1
      this.getPOrderList(Qs.stringify({
        uid: this.uid,
        deviceId: this.deviceId,
        accessToken: this.token,
        pageNumber: this.pageNumber,
        language: this.lang
      }))
    }
  },
  computed:{
    ...mapGetters(['uid', 'deviceId', 'token', 'lang']),
    ...mapGetters('user', ['loadingP', 'pOrderList']),
    status: $vm => {
      return [
        {
          text: $vm.$t('all'),
          value: ''
        },
        {
          text: $vm.$t('toBePaid'),
          value: '0'
        },
        {
          text: $vm.$t('tradeSuccess'),
          value: '100'
        }
      ]
    },
    formatDate: (val, key = false) => {
      return (val, key= false) => {
        let payDate = new Date(parseInt(val));
        if(key){
          return payDate.getFullYear() + '-' + (payDate.getMonth() + 1) + '-' + payDate.getDate() + '  ' + payDate.getHours() + ':' + payDate.getMinutes() + ':' + payDate.getSeconds() + '    ' + 'UTC+' + (0 - new Date().getTimezoneOffset() / 60);
        } else {
          return payDate.getFullYear() + '-' + (payDate.getMonth() + 1) + '-' + payDate.getDate() + '  ' + payDate.getHours() + ':' + payDate.getMinutes() + ':' + payDate.getSeconds()
        }
      }
    },
    formatStatus: $vm => {
      return val => {
        if(val === '0'){
          return $vm.$t('toBePaid')
        } else if(val === '50'){
          return $vm.$t('paymentSuccess')
        } else if(val === '100'){
          return $vm.$t('tradeSuccess')
        }
      }
    }
  },
  mounted(){
    this.$watch('loadingP', val => {
      if(val === 'loadedP'){
        this.pOrderList.list.map(val => {
          this.orderList.push(val)
        })
        // console.log(this.orderList)
        if(this.orderList.length == this.pOrderList.total){
          this.finished = true
        }
        this.loadStatus = false
        this.listLoading = false
      }
    })
    this.$watch('active', val => {
      this.pageNumber = 1
      this.loadStatus = true
      this.finished = false
      this.orderList = []
      this.getPOrderList(Qs.stringify({
        uid: this.uid,
        deviceId: this.deviceId,
        accessToken: this.token,
        pageNumber: 1,
        status: val
      }))
    })
  }
}
</script>
<style lang="scss">
.consume{
  margin: 20px;
  .van-dropdown-menu__item{
    margin: 0 4px;
  }
  .van-dropdown-menu__title::after{
    right: 0px;
  }
  .select_box{
    width: 50%;
    position: relative;
    left: 50%;
    .van-dropdown-menu__bar{
      height: 30px;
    }
  }
  .consume_list{
    margin-top: 10px;
    .van-cell__value{
      position: absolute;
      right: 40px;
      line-height: 60px;
      p{
        margin: 0;
      }
    }
    .van-cell__right-icon{
      line-height: 60px;
    }
    .van-collapse-item__content{
      p{
        margin: 0;
        padding: 5px 10px;
      }
    }
  }
  .consume_icon{
    height: 60px;
    width: 60px;
    position: relative;
  }
  .title{
    margin: 0;
    font-size: 18px;
    color: #000;
    padding-left: 10px;
    font-weight: bolder;
  }
  .time{
    margin: 0;
    font-size: 12px;
    color: #969799;
    padding-left: 10px;
    margin-top: 12px;
  }
  .van-hairline--top-bottom::after{
    border-width: 0px;
  }
}
</style>